import { commonUtils } from '@/helpers/commonUtils'
import styles from './PdfPageMomentCover.module.less'
import PdfPage from '../PdfPage/PdfPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPageMomentCover({ onRendered, no }: Props) {
  const { t } = useTranslation()
  useEffect(() => {
    onRendered(1)
  }, [])

  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-3/PDF-bg-3.jpg')} no={no}>
      <div className={styles.pdfPageMomentCover}>
        <img
          className={styles.cntTitle}
          src={commonUtils.getImagePath('PDFDownload/03.png')}
          alt=''
        />
        <img
          className={styles.circle}
          src={commonUtils.getImagePath('PDFDownload/pdf-page-3/page3-icon.png')}
        />
        <div className={styles.desc}>
          {t('dashboard.projectDetailPage.detailAnalysis')}
          {/* Moment <span className={styles.underline}>Analysis</span> */}
        </div>
      </div>
    </PdfPage>
  )
}

export default PdfPageMomentCover
